import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_OVERTIME_REQUESTS } from "variables/constants";
import OvertimeRequests from "./index";

const overtimesRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Overtime Requests",
		basePath: "overtime-requests",
		mainComponent: <OvertimeRequests />,
	    layout: "/console",	   
	    icon: <FaPersonWalkingLuggage className="icon-item" />,
	    subTitle:"Overtime Request",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_OVERTIME_REQUESTS,
	})
]

export default overtimesRequestRoutes;